import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: 20,
    padding: 16,
    boxShadow: 'none',
    display: 'flex',
    gap: 20,
    '& p': {
      margin: 0
    }
  },
  contentImage: {
    width: 180,
    height: 180,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0
  },
  contentMain: {
    width: '100%'
  },
  mainItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8
  },
  mainItemTitle: {
    fontSize: 16,
    color: '#666',
    fontWeight: 500,
    width: 200,
    flexShrink: 0,
    '& span': {
      color: theme.palette.error.main
    }
  },
  mainItemSpacer: {
    width: 20,
    flexShrink: 0
  },
  mainItemValue: {
    fontSize: 16,
    color: '#333',
    fontWeight: 500
  },
  mainItemInput: {
    width: '50%',
    height: 36,
    padding: '0 12px',
    border: '1px solid #aaa',
    borderRadius: 4,
    fontSize: 14,
    outline: 'none',
    color: '#333',
    fontWeight: 500,
    '&:focus': {
      borderColor: '#333'
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      display: 'none'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      marginTop: 4,
      marginLeft: -12
    }
  },
  mainItemOrder: {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
  },
  mainQuantityControl: {
    border: '1px solid #aaa',
    borderRadius: 4,
    padding: '4px 8px'
  },
  glAccountAutocomplete: {
    '& .MuiInputBase-root': {
      minHeight: 36,
      paddingTop: '4px !important'
    }
  },
  cartButton: {
    marginBottom: '0px !important',
    padding: '0px 10px !important',
    lineHeight: 'unset',
    '& svg': {
      margin: '0px !important'
    }
  }
}))

export { useStyles }
